/**
 * FinalCtaSection — big closing call-to-action with orb background,
 * join-count subcopy, and two CTA buttons.
 */

import { useTranslation } from 'react-i18next';

import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

import {
  BtnPrimary,
  BtnGhost,
  HeroGrain,
  HeadlineShimmer,
  HeroActions,
  SectionEyebrow,
  CtaSection,
  CtaBg,
  CtaOrb,
  CtaInner,
  CtaTitle,
  CtaSub,
} from '../../common/LandingPage.styled';
import type { RoundedStat } from '../../common/stats';

export interface FinalCtaSectionProps {
  /** Writer count injected into the subcopy. */
  writers: RoundedStat;
}

export function FinalCtaSection({ writers }: FinalCtaSectionProps) {
  const { t } = useTranslation();

  return (
    <CtaSection>
      <CtaBg>
        <CtaOrb />
        <HeroGrain />
      </CtaBg>
      <CtaInner>
        <SectionEyebrow>{t('landing.cta.eyebrow')}</SectionEyebrow>
        <CtaTitle>
          {t('landing.cta.title')}
          <br />
          <HeadlineShimmer>{t('landing.cta.titleEm')}</HeadlineShimmer>
        </CtaTitle>
        <CtaSub>{t('landing.cta.sub', { count: writers.value.toLocaleString() })}</CtaSub>
        <HeroActions style={{ justifyContent: 'center' }}>
          <BtnPrimary to="/register">
            {t('landing.cta.primary')} <ArrowForwardIcon />
          </BtnPrimary>
          <BtnGhost to="/login">{t('landing.cta.secondary')}</BtnGhost>
        </HeroActions>
      </CtaInner>
    </CtaSection>
  );
}

export default FinalCtaSection;
